import SurveyBackgroundLayout from '@/components/layout/SurveyBackgroundLayout';
import { useTranslation } from '@/hooks/useTranslation';

export default function ThankYou() {
  const { t } = useTranslation();
  return (
    <SurveyBackgroundLayout>
      <div className="relative z-10 flex min-h-0 flex-1 flex-col items-center justify-center overflow-hidden px-6 py-8 text-center">
        <h1 className="text-[36px] font-semibold leading-tight tracking-tight text-white drop-shadow-[0_2px_12px_rgba(0,0,0,0.45)] sm:text-[42px]">
          {t.thankYou.title}
        </h1>
        <p className="mt-2 text-[22px] font-semibold leading-tight tracking-tight text-white drop-shadow-[0_2px_12px_rgba(0,0,0,0.45)] sm:text-[28px]">
          {t.thankYou.subtitle}
        </p>
      </div>
    </SurveyBackgroundLayout>
  );
}
